import api from '@api';
import { call, put, select, takeEvery, all } from 'redux-saga/effects';
import {
    getTasksGridFetchSuccess,
    getTasksGridFetchFailure,
    confirmTaskFetchSuccess,
    confirmTaskFetchFailure,
} from './reducer';
import { TasksGridResType } from 'src/types/tasksGrid';
import { GridRequestType } from 'src/types/table';
import { ORDER_GRID_URL } from '../ordersGrid/sagas';
import { ORDERS_REQUEST_DATA, RECEIVING_REQUEST_DATA, TASKS_GRID_URL, TASKS_REQUEST_DATA } from './constants';
import { formatData, formatOrders, formatReceivings, formatTasks, transalteTexts } from './functions';
import { RECEIVING_GRID_URL } from '../receivingsGrid/sagas';
import moment from 'moment';
import { RootStoreType } from 'src/types/store';
import { ConstantsCodesObjectType } from 'src/types/constantsCodes';

export interface GetOrderExpeditionPackageGridCallPayloadType {
    params: GridRequestType;
}

const getOrdersRequest = async () => {
    const res = await api('post', ORDER_GRID_URL, ORDERS_REQUEST_DATA);
    return res.data.data;
};
const getReceivingsRequest = async () => {
    const requestData = JSON.parse(JSON.stringify(RECEIVING_REQUEST_DATA));
    const nextMorning = moment().add(1, 'days').startOf('day');
    requestData.filters[0].push({ column: 'ESTIMATED_DELIVERY', operator: 'lt', value: nextMorning });
    const res = await api('post', RECEIVING_GRID_URL, requestData);
    return res.data.data;
};
const getTasksRequest = async () => {
    const res = await api('post', TASKS_GRID_URL, TASKS_REQUEST_DATA);
    return res.data.data;
};

function* getTasksGridFetch(action: { type: string; payload?: GetOrderExpeditionPackageGridCallPayloadType }) {
    try {
        const [responseOrders, responseReceivings, responseTasks]: TasksGridResType[] = yield all([
            call((): any => getOrdersRequest()),
            call((): any => getReceivingsRequest()),
            call((): any => getTasksRequest()),
        ]);

        const orderStatusCodesObject: ConstantsCodesObjectType = yield select(
            (state: RootStoreType) => state.constantsCodes.objects.orderStatusCodes
        );
        const receivingStatusCodesObject: ConstantsCodesObjectType = yield select(
            (state: RootStoreType) => state.constantsCodes.objects.receivingStatusCodes
        );
        const claimStatusCodesObject: ConstantsCodesObjectType = yield select(
            (state: RootStoreType) => state.constantsCodes.objects.claimStatusCodes
        );

        yield put(
            getTasksGridFetchSuccess(
                formatData(
                    [
                        ...formatOrders(responseOrders.data),
                        ...formatReceivings(responseReceivings.data),
                        ...formatTasks(responseTasks.data),
                    ],
                    orderStatusCodesObject,
                    receivingStatusCodesObject,
                    claimStatusCodesObject
                )
            )
        );
    } catch (error) {
        yield put(getTasksGridFetchFailure({ error }));
    }
}

export function* getTasksGridFetchWatch() {
    yield takeEvery('tasks/getTasksGridFetch', getTasksGridFetch);
}

const confirmTaskRequest = async (idTask: string) => {
    const res = await api('put', `api/secure/tasks/${idTask}/confirm`);
    return res.data.data;
};

function* confirmTaskFetch(action: { type: string; payload: string }) {
    try {
        const response: { data: any } = yield call((): any => confirmTaskRequest(action.payload));
        yield put(confirmTaskFetchSuccess(response));
    } catch (error) {
        yield put(confirmTaskFetchFailure({ error }));
    }
}

export function* confirmTaskFetchWatch() {
    yield takeEvery('tasks/confirmTaskFetch', confirmTaskFetch);
}
